import { QuestionMark } from "@mui/icons-material";
import {
  Box,
  Button,
  Typography,
  Tooltip,
  styled,
  tooltipClasses,
} from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

export default function HelpButton({
  id,
  text,
  variant = "outlined",
  sx = {},
  children = null,
  onOpen = () => {},
  onClose = () => {},
  value = null,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    value === null && setIsOpen(true);
    onOpen && onOpen();
  }, [onOpen, value]);

  const handleClose = useCallback(() => {
    value === null && setIsOpen(false);
    onClose && onClose();
  }, [onClose, value]);

  useEffect(() => {
    value !== null && setIsOpen(value);
  }, [value]);

  const HelpContent = useMemo(() => {
    if (text) {
      return <Typography sx={{ p: 2 }}>{text}</Typography>;
    } else {
      return <Box sx={{ p: 2 }}>{children}</Box>;
    }
  }, [text, children]);

  return (
    <Box sx={sx}>
      <LightTooltip
        title={HelpContent}
        open={isOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        leaveDelay={500}
      >
        <Button
          aria-describedby={id}
          variant={variant}
          sx={{
            borderRadius: "50%",
            width: "25px",
            height: "25px",
            minWidth: "0px",
            minHeight: "0px",
            p: "clamp(10px, 4vw, 16px)",
            "& .MuiSvgIcon-root": {
              width: "clamp(0.8em, 4vw, 1em)",
              height: "clamp(0.8em, 4vw, 1em)",
            },
          }}
        >
          <QuestionMark />
        </Button>
      </LightTooltip>
    </Box>
  );
}
